import { render, staticRenderFns } from "./PosStudioMappingTable.vue?vue&type=template&id=6f9e86dd"
import script from "./PosStudioMappingTable.vue?vue&type=script&lang=js"
export * from "./PosStudioMappingTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports